"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function setSourceUploadStatus(sourceId, status) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_SOURCE_UPLOAD_STATUS, {
    sourceId: sourceId,
    status: status
  });
}
var _default = exports["default"] = setSourceUploadStatus;